import { render } from "./BaseSpinner.vue?vue&type=template&id=b1f0541e&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=b1f0541e&scoped=true&lang=css"
import "./BaseSpinner.vue?vue&type=style&index=1&id=b1f0541e&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f0541e"]])

export default __exports__